import { max } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import {
  DATE_FNS_YYYY_MM_DD,
  endOfDayFromQP,
  parseYyyyMmDdInTimeZone,
  startOfDayFromQP,
} from 'garaje/utils/date-fns-tz-utilities';

export const DATE_RANGE_PRESETS: string[] = [
  'today',
  'yesterday',
  'next2Days',
  'thisWeek',
  'next7Days',
  'next30Days',
  'thisMonth',
  'past7Days',
  'past30Days',
  'past90Days',
  'monthToDate',
  'yearToDate',
  'pastYear',
  'allTime',
];

/**
 * Get today as a formatted string in the given timezone
 */
export function todayAsString(timezone: string, format: string = DATE_FNS_YYYY_MM_DD): string {
  return formatInTimeZone(new Date(), timezone, format);
}

/**
 * Get the current day's start in the given timezone as a Date object
 */
export function todayStartDateInTimeZone(timezone: string, now: Date = new Date()): Date {
  const today = formatInTimeZone(now, timezone, DATE_FNS_YYYY_MM_DD);

  return parseYyyyMmDdInTimeZone(today, now, timezone);
}

/**
 * Parse start date query param to Date object with start of day
 */
export function parseStartDate(startDateQP: string | null, defaultDate: string, timezone: string): Date {
  return startOfDayFromQP(startDateQP ?? defaultDate, timezone);
}

/**
 * Parse end date query param to Date object with end of day
 */
export function parseEndDate(endDateQP: string | null, defaultDate: string, timezone: string): Date {
  return endOfDayFromQP(endDateQP ?? defaultDate, timezone);
}

/**
 * Format date for query param (YYYY-MM-DD)
 */
export function formatForQueryParam(date: Date, timezone: string): string {
  return formatInTimeZone(date, timezone, DATE_FNS_YYYY_MM_DD);
}

/**
 * Calculate the target date for new invites (max of start date and today)
 */
export function newInviteTargetDate(startDate: Date, timezone: string): string {
  const targetDate = max([startDate, new Date()]);
  return formatForQueryParam(targetDate, timezone);
}
